import { BrowserRouter, Route, Routes } from 'react-router-dom'

import styles from 'app/App.module.scss'
import PageRouter from 'pages/PageRouter'
import { AnalyticsActionType } from 'types/common/analytics.type'
import { EVENTS, trackAnalytics } from 'utils/analytics'

import AmbitionSubhead from '../components/ambitionSubhead/AmbitionSubhead'
import BottomArc from '../components/bottomArc/BottomArc'
import ExploreSubhead from '../components/exploreSubhead/ExploreSubhead'
import MainBanner from '../components/mainBanner/MainBanner'
import PartnersSubhead from '../components/partnersSubhead/PartnersSubhead'
import ProjectsSubhead from '../components/projectsSubhead/ProjectsSubhead'
import VideoSliderComponent from '../components/videoSliderSubhead/videoSliderComponent'

export function App() {
  trackAnalytics({
    type: AnalyticsActionType.page,
    payload: EVENTS.PAGE.EXPLOOP,
  })

  const showNewXL = process.env.REACT_APP_FEATURE_FLAG_SHOW_NEW_XL === '1'

  if (showNewXL) {
    return (
      <BrowserRouter basename="/experience-loop-process">
        <Routes>
          <Route path="*" element={<PageRouter />} />
        </Routes>
      </BrowserRouter>
    )
  }

  return (
    <BrowserRouter basename="/experience-loop-process">
      <div className={styles.container}>
        <MainBanner />
        <AmbitionSubhead />
        <ExploreSubhead />
        <ProjectsSubhead />
        <PartnersSubhead />
        <VideoSliderComponent />
        <BottomArc />
      </div>
    </BrowserRouter>
  )
}
